import { Box, Divider, Grid } from "@mui/material";
import { KeyDriveh2Header } from "../../../../components/KeydriveComponents/Fonts/Headers/KeyDriveh2Header";
import { KeyDriveCaption } from "../../../../components/KeydriveComponents/Fonts/Captions/KeyDriveCaption";
import RegisterIndicator from "./RegisterIndicator";
import { KeyDriveBodyMax } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import { IStepHandler, IStepItem } from "../Register";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { useTranslation } from "react-i18next";

export interface IRegisterPageLeft {
    steps: IStepItem[];
    step: number;
}

export default function RegisterPageLeft({
    steps,
    step
}: IRegisterPageLeft) {

    const { t } = useTranslation();

    return (
        <Grid item xs={5} paddingLeft="8px" paddingRight="8px" display="flex" height="100vh" justifyContent="center" alignItems="center">
            <Box
                display="flex"
                flexDirection="column"
                height="500px"
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "16px"
                    }}
                >
                    <Box
                        sx={{
                            paddingBottom: "16px"
                        }}
                    >
                        <KeyDriveh2Header 
                            color="#000"
                            needBold={false}
                            needEllipses={false}
                            text={t("RegisterPage.pageTitle")}
                        />
                    </Box>
                    <Box
                        sx={{
                            marginBottom: "16px"
                        }}
                    >
                        <KeyDriveCaption 
                            color="#000"
                            needBold={false}
                            needEllipses={false}
                            text={t("RegisterPage.pageDescription")}                        
                        />
                    </Box>
                    <Divider />
                </Box>
                <Box
                    sx={{
                        marginTop: "16px",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    }}
                    >
                    {steps.map((stepItem) => (
                        <Box
                            key={stepItem.stepNumber}
                            display="flex"
                            marginBottom="34px"
                            alignItems="center"
                            maxWidth="540px" 
                            width="100%"
                        >
                        <Box>
                            <RegisterIndicator
                            isActualStep={stepItem.stepNumber === step}
                            numberIndicate={stepItem.stepNumber}
                            isStepConclued={stepItem.stepConcluded}
                        />
                        </Box>
                            <Box marginLeft="12px">
                                <KeyDriveBodyMax
                                    color={stepItem.stepNumber === step ? "#22638D" : "#A7C1D1"}
                                    needBold
                                    needEllipses={false}
                                    text={stepItem.stepTitle}
                                />
                                <KeyDriveBodyMin
                                    color="#7AA1BB"
                                    needBold={false}
                                    needEllipses={false}
                                    text={stepItem.stepContent}
                                />
                            </Box>
                        </Box>
                    ))}
                    </Box>
            </Box>
        </Grid>
    )
}